import { getIn, useFormikContext } from 'formik'

function isVisuallyEmptyString(value: string): boolean {
    const text = value
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim()
    return text === ''
}

function valuesDifferFromInitial(a: unknown, b: unknown): boolean {
    if (Object.is(a, b)) {
        return false
    }
    if (typeof a === 'string' && typeof b === 'string') {
        if (isVisuallyEmptyString(a) && isVisuallyEmptyString(b)) {
            return false
        }
        return a !== b
    }
    if (typeof a === 'object' && a !== null && typeof b === 'object' && b !== null) {
        try {
            return JSON.stringify(a) !== JSON.stringify(b)
        } catch {
            return true
        }
    }
    return true
}

export function useFieldErrorVisible(name: string): boolean {
    const { errors, touched, values, initialValues } = useFormikContext()
    const error = getIn(errors, name)
    if (!error) {
        return false
    }
    if (!getIn(touched, name)) {
        return false
    }
    const current = getIn(values, name)
    const initial = getIn(initialValues, name)
    return valuesDifferFromInitial(current, initial)
}
